<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Territorios Anualizado
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Territorios Anualizado</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

      <div class="row mt-2 filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-select label="Gestión" [options]="optionsYear" placeholder="Gestión" [filterEnabled]="true"
              formControlName="anno">
            </mdb-select>
            <div *ngIf="
                  formHeader.get('anno').invalid &&
                  (formHeader.get('anno').dirty ||
                  formHeader.get('anno').touched)
                ">
              <mdb-error *ngIf="formHeader.get('gestion').hasError('required')">Ingrese gestión
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="md-form" style="max-width: 300px">
            <mdb-select [options]="optionsTerritorio" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaTerritorio"></mdb-select>
            <label>Territorio</label>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)"><mdb-icon fas icon="search"></mdb-icon>Buscar</button>
      </div>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Territorio</th>
            <!-- <th scope="col">Zona</th> -->
            <th scope="col" class="text-right">Ene</th>
            <th scope="col" class="text-right">Feb</th>
            <th scope="col" class="text-right">Mar</th>
            <th scope="col" class="text-right">Abr</th>
            <th scope="col" class="text-right">May</th>
            <th scope="col" class="text-right">Jun</th>
            <th scope="col" class="text-right">Jul</th>
            <th scope="col" class="text-right">Ago</th>
            <th scope="col" class="text-right">Sep</th>
            <th scope="col" class="text-right">Oct</th>
            <th scope="col" class="text-right">Nov</th>
            <th scope="col" class="text-right">Dic</th>
            <th scope="col" class="text-right">Acumulado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{ mov.nombre }}</td>
            <!-- <td>{{ mov.zona }}</td> -->
            <td class="text-right">{{ mov.enero | numerico }}</td>
            <td class="text-right">{{ mov.febrero | numerico }}</td>
            <td class="text-right">{{ mov.marzo | numerico }}</td>
            <td class="text-right">{{ mov.abrir | numerico }}</td>
            <td class="text-right">{{ mov.mayo | numerico }}</td>
            <td class="text-right">{{ mov.junio | numerico }}</td>
            <td class="text-right">{{ mov.julio | numerico }}</td>
            <td class="text-right">{{ mov.agosto | numerico }}</td>
            <td class="text-right">{{ mov.septiembre | numerico }}</td>
            <td class="text-right">{{ mov.octubre | numerico }}</td>
            <td class="text-right">{{ mov.noviembre | numerico }}</td>
            <td class="text-right">{{ mov.diciembre | numerico }}</td>
            <td class="text-right">{{ mov.acumulado | numerico }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right"><strong>Totales</strong></td>
            <td class="text-right">{{ resumen_totales.enero | numerico}}</td>
            <td class="text-right">{{ resumen_totales.febrero | numerico}}</td>
            <td class="text-right">{{ resumen_totales.marzo | numerico}}</td>
            <td class="text-right">{{ resumen_totales.abrir | numerico}}</td>
            <td class="text-right">{{ resumen_totales.mayo | numerico}}</td>
            <td class="text-right">{{ resumen_totales.junio | numerico}}</td>
            <td class="text-right">{{ resumen_totales.julio | numerico}}</td>
            <td class="text-right">{{ resumen_totales.agosto | numerico}}</td>
            <td class="text-right">{{ resumen_totales.septiembre | numerico}}</td>
            <td class="text-right">{{ resumen_totales.octubre | numerico}}</td>
            <td class="text-right">{{ resumen_totales.noviembre | numerico}}</td>
            <td class="text-right">{{ resumen_totales.diciembre | numerico}}</td>
            <td class="text-right">{{ resumen_totales.acumulado | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- <div class="card mb-2 wow" *ngIf="listaMovimientosAll?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <th scope="col"></th>
          <th scope="col">Ene</th>
          <th scope="col">Feb</th>
          <th scope="col">Mar</th>
          <th scope="col">Abr</th>
          <th scope="col">May</th>
          <th scope="col">Jun</th>
          <th scope="col">Jul</th>
          <th scope="col">Ago</th>
          <th scope="col">Sep</th>
          <th scope="col">Oct</th>
          <th scope="col">Nov</th>
          <th scope="col">Dic</th>
          <th scope="col">Acumulado</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Totales</strong></td>
          <td>{{ resumen_totales.enero | numerico}}</td>
          <td>{{ resumen_totales.febrero | numerico}}</td>
          <td>{{ resumen_totales.marzo | numerico}}</td>
          <td>{{ resumen_totales.abrir | numerico}}</td>
          <td>{{ resumen_totales.mayo | numerico}}</td>
          <td>{{ resumen_totales.junio | numerico}}</td>
          <td>{{ resumen_totales.julio | numerico}}</td>
          <td>{{ resumen_totales.agosto | numerico}}</td>
          <td>{{ resumen_totales.septiembre | numerico}}</td>
          <td>{{ resumen_totales.octubre | numerico}}</td>
          <td>{{ resumen_totales.noviembre | numerico}}</td>
          <td>{{ resumen_totales.diciembre | numerico}}</td>
          <td>{{ resumen_totales.acumulado | numerico}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->

<div class="card mb-2 wow" *ngIf="listaMovimientosAll?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
